<template>
  <div id="map" style="width: 100%; height: 500px;"></div>
</template>

<script setup>
import { onMounted } from 'vue';
import { loadBaiduMap } from '@/utils/loadbaidumap';

onMounted(async () => {
  try {
    const BMapGL = await loadBaiduMap();
    const map = new BMapGL.Map('map');
    const center = new BMapGL.Point(116.404, 39.915); // 北京中心点
    map.centerAndZoom(center, 11);
    map.enableScrollWheelZoom(); // 启用滚轮缩放
    map.addControl(new BMapGL.ZoomControl()); // 添加缩放控件
  } catch (error) {
    console.error('地图初始化失败:', error);
  }
});
</script>